import _ from 'lodash';
import appOptions from './appOptions';
import constants from './constants';
import storage from './storage';
import utility from './utility';

// utilities for the native iOS/Android teams
const nativeUtility = {
    /**
     * Verify this is running in the context of a native app, and
     * the native app JS interface is defined.
     * @returns {boolean}
     */
    isNativeAndModuleDefined() {
        try {
            // Android will be a universal variable injected to our scripts by the Android system
            // also check that we are on native android
            return (
                utility.isNativeMobileRequest() &&
                !_.isUndefined(window.Android)
            );
        } catch (e) {
            return false;
        }
    },

    /**
     * Load data supplied by the native app's JS interface into
     * sessionStorage. This is currently only used for checkout
     * form data such as name, email, phone number.
     * @return {boolean} success
     */
    loadAppData() {
        if (_.isUndefined(window.nativeData)) {
            return false;
        }
        let remember = window.nativeData.remember || {};

        // phone numbers will choke the phone number parsing code in
        // phone.js unless they are prefixed with a '+'
        if (!_.isEmpty(remember.phone) && remember.phone.charAt(0) !== '+') {
            remember.phone = `+${remember.phone}`;
        }

        // don't clobber existing storage
        let userContactDetails = _.extend(
            remember,
            storage.get(constants.STORAGE.USER_CONTACT_DETAILS)
        );
        storage.set(constants.STORAGE.USER_CONTACT_DETAILS, userContactDetails);

        return true;
    },

    /**
     * Save data back to the native app. This is currently only
     * used for checkout form data such as name, email, phone
     * number.
     * @return {boolean} success
     */
    saveAppData(data) {
        if (
            !this.isNativeAndModuleDefined() ||
            _.isUndefined(window.Android.remember)
        ) {
            return false;
        }
        window.Android.remember(data);
        return true;
    },

    /**
     * [CHK-891] Remove VAS from native mobile checkouts when they
     * are eligible for native checkout. This feature is to
     * facilitate accurate AB test comparison between native and
     * web checkout. 'nativeCheckoutEligibleV1' is a URL param
     * passed in by the native app. It indicates a listing which
     * could be processed using V1 of native checkout.
     * @returns {boolean}
     */
    shouldSuppressVasProducts() {
        return (
            utility.isNativeMobileRequest() &&
            appOptions.get('nativeCheckoutEligibleV1')
        );
    },
};

export default nativeUtility;
